import {
  ControlInstance
} from "../instance";
class ShapeControl extends ControlInstance {
  constructor(definition, sendMessage) {
    super(sendMessage);
    this.definition = definition;
    this.childControls = new Map(
      Object.entries(this.definition.keyDefs).map(([key, def]) => [
        key,
        this.createChildControl(def, key)
      ])
    );
  }
  static CHILD_CONTROL_MESSAGE = "makeswift::controls::shape::message::child-control-message";
  childControls = /* @__PURE__ */ new Map();
  recv = (message) => {
    switch (message.type) {
      case ShapeControl.CHILD_CONTROL_MESSAGE: {
        this.child(message.payload.key)?.recv(message.payload.message);
      }
    }
  };
  child = (key) => this.childControls.get(key);
  createChildControl = (def, key) => {
    return def.createInstance(
      (message) => this.sendMessage({
        type: ShapeControl.CHILD_CONTROL_MESSAGE,
        payload: { message, key }
      })
    );
  };
}
export {
  ShapeControl
};
//# sourceMappingURL=shape-control.js.map